import axios from "axios";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./product.css";

export default function Product() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [p, setP] = useState({});

  useEffect(() => {
    axios
      .get(`https://apple2.shopat1stop.com/api/product/${id}`)
      .then((res) => setP(res.data));
  }, [id]);

  // ADD TO CART
 const addToCart = async () => {

  const user_id = localStorage.getItem("user_id");

  if (!user_id) {
    alert("Login first ❗");
    return;
  }

  const store_name =
    localStorage.getItem("storeLocation") || "Apple 1";

  try {

    const res = await axios.post(
      "https://apple2.shopat1stop.com/api/cart",
      {
        user_id: parseInt(user_id),
        product_id: parseInt(id),
        store_name: store_name
      }
    );

    alert(res.data.message || "Added to cart ✅");

    window.dispatchEvent(new Event("cartUpdated"));

  } catch (err) {

    console.log(err);
    alert("Add to cart failed ❌");

  }
};

  // BUY NOW
  const handleBuyNow = () => {
    const user_id = localStorage.getItem("user_id");

    if (!user_id) {
      alert("Login first ❗");
      return;
    }

    navigate("/checkout");
  };

  return (
    <div className="product-page">

      {/* LEFT IMAGE */}
      <div className="product-left">
        <img
          src={
            p.image
              ? `https://apple2.shopat1stop.com${p.image}`
              : "https://via.placeholder.com/400"
          }
          alt={p.name}
        />
      </div>

      {/* CENTER DETAILS */}
      <div className="product-center">

        <h1>{p.name}</h1>

        <p className="brand">Brand: {p.brand}</p>

        <p className="rating">⭐ {p.rating} / 5</p>

        <h3 className="price">${p.price}</h3>

        <p className="desc">{p.description}</p>

        <ul className="features">
          <li>✔ High Quality Material</li>
          <li>✔ Smooth Experience</li>
          <li>✔ Premium Packaging</li>
          <li>✔ Fast Delivery</li>
        </ul>

      </div>

      {/* RIGHT BUY BOX */}
      <div className="product-right">

        <h2>${p.price}</h2>

        <p className="delivery">FREE Delivery 🚚</p>

        <button className="cart-btn" onClick={addToCart}>
          Add to Cart
        </button>

        <button className="buy-btn" onClick={handleBuyNow}>
          Buy Now ⚡
        </button>

      </div>

    </div>
  );
}